import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Flights from "../flights/index";
import Dcs from "../dcs/index";
import Login from "../authentication/login";
import Logout from "../authentication/logout";
import Compare from "../compare/index"
import InventoryUpdater from "../inventoryUpdater";
import Admin from '../admin/index'
import PaxSearch from '../paxSearch/index';
import Profile from '../profile';
import ForgotPassword from '../authentication/forgotPassword';
import Bulk from "../bulk/index";
import styles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route, withRouter, Redirect, useHistory } from 'react-router-dom';
import { NavListItem } from './components'
import pageAccess from '../mainDisplay/pageAccess.json'
import Filters from '../flights/filters';
import { setFlightDate } from "../../store/flights";
import { changeDestination, changeFlightNumber, changeOrigin, changePassenger, changeRloc, changeTailNumber, changeStatus, setShowFilter } from "../../store/dcs";

import _ from 'lodash'

const checkAccess = (user, page) => {
  let hasAccess = false
  if (user?.user_type?.length && user?.airline_id?.length) {
    let userType = user.user_type.toLowerCase()
    let userAirline = user.airline_id.toUpperCase()
    let userAccess = pageAccess[page].userTypeAccess.includes(userType)
    let airlineAccess = pageAccess[page].userAirlineAccess.includes(userAirline)

    hasAccess = userAccess && airlineAccess
  }

  return hasAccess
}

const MainDisplay = (props) => {
  const dispatch = useDispatch()
  const getIsMobile = () => window.innerWidth <= 600;
  const theme = useTheme();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  let [page, setPage] = React.useState('Flights')
  const [initialLogin, setInitialLogin] = useState(false);
  const [isMobile, setIsMobile] = useState(getIsMobile());
  const classes = styles({ isMobile: isMobile, theme: theme });
  const flights = useSelector(state => state.entities.flights.list)
  const showFilter = useSelector(state => state.entities.dcs.showFilter);
  const [statusFilter, setStatusFilter] = useState(['Active'])
  const [originFilter, setOriginFilter] = useState([])
  const [regionFilter, setRegionFilter] = useState([])
  const [destinationFilter, setDestinationFilter] = useState([])

  // const [statusFilter, setStatusFilter] = useState(() => {
  //   return statusFilterFromRedux || ['Active'];
  // });
  // const [originFilter, setOriginFilter] = useState(() => {
  //   return originFilterFromRedux || [];
  // });
  // const [regionFilter, setRegionFilter] = useState([])
  // const [destinationFilter, setDestinationFilter] = useState(() => {
  //   return destFilterFromRedux || [];
  // });

  const flightDate = useSelector(state => state.entities.flights.flightDate)

  const changeFlightDate = (event) => {
    dispatch(setFlightDate(event.target.value))
  }
  //To clear the DCS page Fliter while Redirecting
  const clearFilters = () => {
    dispatch(changeDestination('None'))
    dispatch(changeFlightNumber('None'))
    dispatch(changeOrigin('None'))
    dispatch(changeTailNumber('None'))
    dispatch(changeRloc(''))
    dispatch(changePassenger(''))
    dispatch(changeStatus('Active'))
    dispatch(setShowFilter(false));
  }
  let filterProps = {
    status: { val: statusFilter || '', set: setStatusFilter },
    origin: { val: originFilter || '', set: setOriginFilter },
    region: { val: regionFilter || '', set: setRegionFilter },
    dest: { val: destinationFilter || '', set: setDestinationFilter },
    date: { val: flightDate || '', set: changeFlightDate }
  }
  useEffect(() => {
    dispatch(setShowFilter(false));
    // Clear the Filters in flights when redirecting 
    // setStatusFilter(['Active']);
    // setOriginFilter([]);
    // setRegionFilter([]);
    // setDestinationFilter([]);
    // Clear the Filters in dcs when redirecting 
    // clearFilters();
    const onResize = () => {
      setIsMobile(getIsMobile());
    }

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
    }
  }, [props.location.pathname]);

  const originFilterFromRedux = useSelector(state => state.entities.dcs.origin)
  const destFilterFromRedux = useSelector(state => state.entities.dcs.destination)
  const statusFilterFromRedux = useSelector(state => state.entities.dcs.status)
  useEffect(() => {
    if (props.location.pathname == "/dcs") {
      const setOrgin = originFilterFromRedux !== "None" && originFilterFromRedux !== "" ? [originFilterFromRedux] : []
      const setDestination = destFilterFromRedux !== "None" && destFilterFromRedux !== "" ? [destFilterFromRedux] : []
      const setStatus = statusFilterFromRedux === "Cancelled" || statusFilterFromRedux === "Active" ? [statusFilterFromRedux] : ['Active'];
      setOriginFilter(setOrgin)
      setDestinationFilter(setDestination)
      setStatusFilter(setStatus)
    }

  }, [props.location.pathname, originFilterFromRedux, destFilterFromRedux, statusFilterFromRedux])


  const token = useSelector(state => state.entities.auth.token);
  const user = token ? JSON.parse(window.atob(token.split('.')[1])) : '';

  const handleDrawer = () => {
    setOpen(!open);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawer}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
          <Typography variant="h6" className="mainHeader" noWrap>
            {page}
            <Filters filters={filterProps} flights={flights} classes={classes} isMobile={isMobile} />
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
          [classes.showFilter]: showFilter
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={() => { }}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        <List className={{ [classes.showFilter]: showFilter }} >
          <NavListItem label={"Flights"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={checkAccess(user, "flights")} handleDrawer={handleDrawer} />
          <NavListItem label={"DCS"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={checkAccess(user, "dcs")} handleDrawer={handleDrawer} />
          <NavListItem label={"Pax-Search"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={checkAccess(user, "pax-search")} handleDrawer={handleDrawer} />
          <NavListItem label={"Inventory-Updater"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={checkAccess(user, "inventory")} handleDrawer={handleDrawer} />
          <NavListItem label={"Admin"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={checkAccess(user, "admin")} handleDrawer={handleDrawer} />
          <NavListItem label={"Profile"} classes={classes} isMobile={isMobile} isOpen={open} hasAccess={user.user_type && !!user.user_type.length} handleDrawer={handleDrawer} />
          <NavListItem label={"Login"} classes={classes} isMobile={isMobile} isOpen={open} handleDrawer={handleDrawer} />
          <NavListItem label={"Logout"} classes={classes} isMobile={isMobile} isOpen={open} handleDrawer={handleDrawer} />
        </List>
      </Drawer>

      <main className={clsx(classes.content, {
        [classes.showFilter]: showFilter,
      })} style={{ overflow: 'hidden' }}>
        <div className={classes.toolbar} />
        {/* !SECTION */}
        {/* SECTION // Routes (page displayed) */}
        <div>
          <Switch>
            <Route exact path={["/flights", '/']} render={(props) => {
              setPage('Flights')
              if (token) {
                return (
                  <Flights {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} statusFilter={statusFilter}
                    originFilter={originFilter} destinationFilter={destinationFilter} regionFilter={regionFilter} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }} />

            <Route exact path="/dcs" render={(props) => {
              setPage('DCS')
              if (token) {
                return (
                  <Dcs {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            <Route exact path="/pax-search" render={(props) => {
              setPage('Pax-Search')
              // TODO // remove newPage permission requirement
              if (token) {
                return (
                  <PaxSearch {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            <Route exact path="/profile" render={(props) => {
              setPage('Profile')
              return (
                <Profile {...props} isMobile={isMobile} />
              )
            }} />

            <Route exact path="/compare" render={(props) => {
              // FIXME // I can't figure out why setPage() isn't working here
              setPage('Compare')
              if (token) {
                return (
                  <Compare {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            <Route exact path="/admin" render={(props) => {
              setPage('Admin')
              if (token) {
                return (
                  <Admin {...props} userType={user.user_type} userAirline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            <Route exact path="/inventory-updater" render={(props) => {
              setPage('Inventory-Updater')
              if (token) {
                return (
                  <InventoryUpdater {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            <Route exact path="/bulk" render={(props) => {
              setPage('Bulk')
              if (token) {
                return (
                  <Bulk {...props} user_type={user.user_type} airline={user.airline_id} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }
            } />

            {/* <Route exact path="/login" render={(props) =>{
                    setPage(`Login`)
                    if (!token) {
                      return (
                        <Login {...props} isMobile={isMobile} theme={theme} />
                      )
                    } else {
                      return (
                        <Redirect to="/logout" />
                      )
                    }
                  }}/>
                  <Route exact path="/logout" render={(props) =>{
                    setPage(`Logout`)
                    if (token) {
                      return (
                        <Logout {...props} isMobile={isMobile} theme={theme} />
                      )
                    } else {
                      return (
                        <Redirect to="/login" />
                      )
                    }
                  }}/> */}

            <Route exact path="/login" render={(props) => {
              setPage("Login");
              if (!token) {
                return (
                  <Login {...props} isMobile={isMobile} theme={theme} />
                );
              } else if (initialLogin) {
                // Redirect to "/logout" if initialLogin is true
                history.push('/logout'); // Redirect to "/logout"
                window.location.reload(); // Refresh the page
                return null; // You can return null since the page will be refreshed
              } else {
                // Redirect to "/dcs" if initialLogin is false
                setInitialLogin(true);
                return (
                  <Redirect to="/dcs" />
                );
              }
            }} />

            <Route exact path="/logout" render={(props) => {
              setPage(`Logout`)
              if (token) {
                return (
                  <Logout {...props} isMobile={isMobile} theme={theme} />
                )
              }
              else {
                return (
                  <Redirect to="/login" />
                )
              }
            }} />

            <Route exact path="/forgot-password" render={(props) => {
              setPage(`Forgot Password`)
              if (!token) {
                return (
                  <ForgotPassword {...props} isMobile={isMobile} />
                )
              } else {
                return (
                  <Redirect to="/profile" />
                )
              }
            }} />

            {/* <Route exact path="/reservations/:id" render={(props) =>{
              setPage(`Reservations Edit ${props.match.params.id}`)
              return (
                <div>
                  <p>reservations/:id</p>
                </div>
              )
            }}/> */}
          </Switch>
        </div>
        {/* !SECTION */}
      </main>
    </div>
  );
}

export default withRouter(MainDisplay)